export const FOOD_SCHEDULE_OPTIONS = [
	{
		title: 'Morning',
		description: 'Available with early drop-off',
		category: 'meal',
		time: 'morning',
		disabledWhen: { early_dropoff: false }
	},
	{
		title: 'Midday',
		description: '',
		category: 'meal',
		time: 'midday'
	},
	{
		title: 'Evening',
		description: 'Available with late pick-up',
		category: 'meal',
		time: 'evening',
		disabledWhen: { extended_pickup: false }
	}
]
